import jsonp from './jsonp'
import { getParams } from './param-factory'
import { getLeftYMD, isInApp } from '@/utils/mUtil'

const HOST = 'https://credits.bz.mgtv.com'
// const HOST = 'https://credits-beta.bz.mgtv.com'
const CONF_HOST = 'https://layer.bz.mgtv.com'
const DRAW_HOST = 'https://club.api.mgtv.com'
const ODIN_HOST = 'https://mob.bz.mgtv.com'
// const ODIN_HOST = 'https://st.bz.mgtv.com'
const BANNER_HOST = 'https://banner.api.mgtv.com'
const USER_HOST = 'https://nuc.api.mgtv.com'

// const HAOWU_HOST = 'https://shoptest.api.mgtv.com' //好物测试环境
const HAOWU_HOST = 'https://shop.api.mgtv.com' //好物线上环境
const ACTIVITY_HOST = 'https://common-activity.bz.mgtv.com'

const devIsLogin = 1

/**
 * 
 * 获取用户信息
 */
export async function getUserInfo() {
  return new Promise((resolve, reject) => {
    if (isInApp()) {
      MgtvApi.getUserInfo(data => {
        resolve(data && JSON.parse(data).ticket ? JSON.parse(data) : {})
      })
    } else {
      const userInfo = {}
      if (localStorage.getItem('ticket')) {
        userInfo.uuid = localStorage.getItem('uuid')
        userInfo.ticket = localStorage.getItem('ticket')
      }
      resolve(userInfo)
    }
  })
}

/**
 * 获取设备信息
 */
export async function getDeviceInfo() {
  return new Promise((resolve, reject) => {
    if (isInApp()) {
      MgtvApi.getDeviceInfo(data => {
        resolve(JSON.parse(data))
      })
    } else {
      resolve({})
    }
  })
}

/**
 * 获取主活动aid以及转盘aid
 * @param {*} is_preview
 */
export async function getAid(is_preview) {
  return jsonp(
    HOST + '/activity/conf',
    getParams({
      aid: 1,
      is_preview,
    })
  )
}

/**
 * 获取兑吧商品列表
 */
export async function getDBItemList() {
  return jsonp(HOST + '/db/getItemList', getParams())
}

/**
 * 商品分类
 */
export async function getCategorys() {
  return jsonp(HOST + '/db/getCategorys', getParams())
}

/**
 * 根据分类ID获取商品
 * @params categoryId 分类id
 */
export async function getCategoryGoodList(categoryId) {
  return jsonp(HOST + '/db/getCategoryGoodList', getParams({ categoryId }))
}

/**
 * 商品销售Top榜/精选榜
 * @params type 区分榜单类型 0销量 1精选
 */
export async function getCategoryGoodsByName(type) {
  return jsonp(HOST + '/db/getCategoryGoodsByName', getParams({ type }))
}

/**
 * 获取兑吧秒杀商品列表
 * 2019-10-28替换新接口
 */
export async function getNewDBSeckillGoods() {
  return jsonp(HOST + '/db/seckillGoodsV2', getParams())
}

/**
 * 查询积分日常任务
 * @params types 积分类型
 *         switch 消息通知开关状态。0-未打开；1-已打开。
 */
export async function getUserCreditsTask(types, swi = 0) {
  return jsonp(
    HOST + '/user/creditsTask',
    getParams({
      types,
      switch: swi,
    })
  )
}

/**
 * 积分领取
 * @params type 积分类型
 */
export async function getUserCreditsTake(params) {
  return jsonp(HOST + '/user/creditsTake', params)
}

/**
 * 积分一键领取
 */
export async function getUserAllCreditsTake(params) {
  return jsonp(HOST + '/user/creditsTakeAll', params)
}

/**
 * 积分排行查询
 */
export async function getRank() {
  return jsonp(HOST + '/user/signTop', getParams({ aid: 7 }))
}

/**
 * 签到提醒开和关
 * @params status 开关状态。1-开；-1关
 */
export async function setCreditsSignRemain({ status }) {
  return jsonp(HOST + '/credits/signRemain', getParams({ status }))
}

/**
 * 获取右下角弹窗的数据
 */
export async function getLayerCreditsConf() {
  return jsonp(
    CONF_HOST + '/layer/credits/conf',
    getParams({
      where: 10,
    })
  )
}

/**
 * 检查时间戳
 */
export async function getVerifyTime(timestamp) {
  return jsonp(
    HOST + '/credits/verifyTime',
    getParams({
      aid: 7,
      timestamp,
    })
  )
}

/**
 * 查询用户积分余额
 */
export async function getUserCreditsBalance() {
  return jsonp(
    HOST + '/user/creditsBalance',
    getParams({
      hideLoading: true,
    })
  )
}

/**
 * 获取抽奖列表
 */
export async function getDrawList(day) {
  return jsonp(
    DRAW_HOST + '/jf/gift/list',
    getParams({
      aid: 7,
      tag: day,
    })
  )
}

/**
 * 进行抽奖
 */
export async function getDraw() {
  return jsonp(
    DRAW_HOST + '/jf/lottery/draw',
    getParams({
      aid: 7,
    })
  )
}

/**
 * 抽奖纪录查询
 */
export async function getDrawHistory(leftDay) {
  const drawDate = getLeftYMD(leftDay)
  return jsonp(
    DRAW_HOST + '/jf/lottery/gift',
    getParams({
      aid: 7,
      drawDate,
    })
  )
}

/**
 * 获取签到弹窗媒资信息
 */
export async function getOdinChannelIndex() {
  return jsonp(
    ODIN_HOST + '/odin/c1/channel/index',
    {
      version: '5.0',
      type: 10,
      // vclassId: 629, // 测试环境
      vclassId: 989, // 线上环境
      // callback: 'mgtvcallback_ci',
      pageNo: 1,
    },
    {
      name: 'mgtvcallback_ci',
    }
  )
}

/**
 * 签到天数查询
 */
export async function getUserSignInfo(uuid) {
  return jsonp(
    HOST + '/user/userSignInfo',
    getParams({
      aid: 7,
      uuid,
    })
  )
}

/**
 * 签到话术
 */
export async function getSignToast() {
  return jsonp(
    HOST + '/credits/signToast',
    getParams({
      aid: 7,
    })
  )
}

/**
 * 获取页面右下角弹窗配置
 */
export async function getBannerList(entrance) {
  return jsonp(
    BANNER_HOST + '/banner/conf',
    getParams({
      entrance: entrance,
    })
  )
}

/**
 * 公告
 */
export async function getNotice() {
  return jsonp(HOST + '/credits/notice', getParams())
}

/**
 * 根据时间及收支类型查询用户积分明细
 */
export async function getCreditsLogByType(params) {
  return jsonp(HOST + '/user/creditsLogByType', getParams(params))
}

/**
 * 秒杀提醒开和关
 * @params status 开关状态。1-开；-1关
 */
export async function setCreditsSecKillRemain(params) {
  return jsonp(HOST + '/credits/secKillRemain', getParams(params))
}

/**
 * 获取服务端用户信息接口
 * @param {*} params
 */
export async function getServerUserInfo() {
  return jsonp(
    USER_HOST + '/GetUserInfo',
    getParams({
      invoker: 'hunantvphone',
    })
  )
}

/**
 * 对接好物
 */
/**
 * 模块列表
 * module_type 模块类型1.积分首页，2.积分商城，3.秒杀模块
 */
export async function getPointsModule(type) {
  return jsonp(HAOWU_HOST + '/api/points/mall/modules', {
    module_type: type,
  })
}

/**
 * 模块商品列表
 */
export async function getModuleGoodsList(params) {
  return jsonp(HAOWU_HOST + '/api/points/mall/module/goods', params)
}

/**
 * 秒杀模块
 */
export async function flashPointsGoods(params) {
  return jsonp(HAOWU_HOST + '/api/points/mall/flash/goods', params)
}

/**
 * 我能兑换
 */
export async function canRedeem(params) {
  return jsonp(HAOWU_HOST + '/api/points/mall/can/redeem', params)
}

/**
 * 兑换跑马灯
 */
export async function getUserBuyScollInfo(params) {
  return jsonp(HAOWU_HOST + '/api/points/mall/buy/scoll', params)
}

/**
 * 任务事件通知
 */
export async function directNotify(type) {
  return jsonp(
    HOST + '/task/directNotify',
    getParams({
      type,
    })
  )
}

/**
 * 积分年度清零展示信息
 */
export async function yearClear() {
  return jsonp(HOST + '/user/yearClear', getParams())
}

/**
 * 全部商品
 */
export async function getAllGoodsList(params) {
  return jsonp(HAOWU_HOST + '/api/points/mall/station/all/goods', params)
}

/**
 * 获取页面各个部分是否显示的配置
 */
export async function getCreditConfig() {
  return jsonp(HOST + '/credits/config')
}


/**
 * 获取口令内容
 */
export async function getShareText() {
  return jsonp(HOST + '/invite/kl', getParams({}))
}

/**
 * 接受口令邀请
 */
export async function doShareSurpport(inviterUuid) {
  return jsonp(HOST + '/invite/join', getParams({ inviterUuid }))
}

export async function getActivityParams(params) {
  return jsonp(
    ACTIVITY_HOST + '/online/third/task/recruitment/exchange',
    getParams({...params}),
  )
}

